import { isNullOrWhiteSpace } from "Utils/String";

export function getQueryParameter(paramName: string): string {
  const params = parseQueryParams();
  return params?.[paramName] ?? null;
}

export function clearQueryParameter(paramName: string): void {
  const params = parseQueryParams();
  if (params?.[paramName] == null) {
    return;
  }

  delete params[paramName];
  const query = Object.entries(params)
    .reduce((out, [key, value]) => [...out, `${key}=${encodeURIComponent(value)}`], [])
    .join(`&`);

  if (isNullOrWhiteSpace(query)) {
    window.location.search = null;
  }

  window.location.search = `?${query}`;
}

function parseQueryParams(): Record<string, string> {
  const query = window.location.search;
  if (isNullOrWhiteSpace(query)) {
    return null;
  }

  return query
    .slice(1)
    .split(`&`)
    .reduce((out, param) => {
      if (isNullOrWhiteSpace(param)) {
        return out;
      }

      const [key, value] = param.split(`=`);
      return {
        ...out,
        [key]: decodeURIComponent(value)
      };
    }, {});
}
